(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lm-header"]) return;
  try {
    
async function lmRefreshCart(){try{const response=await fetch(window.Shopify.routes.root+'cart.js',{headers:{Accept:'application/json'}});if(!response.ok)return;const cart=await response.json();document.querySelectorAll('[data-lm-cart-count]').forEach(el=>{el.textContent=String(cart.item_count)});}catch{}}
import('@shopify/events').then(({StandardEvents})=>{document.addEventListener(StandardEvents.cartLinesUpdate,event=>{if(event.promise){event.promise.then(lmRefreshCart).catch(()=>{});}else{lmRefreshCart();}});}).catch(()=>{});
window.addEventListener('pageshow',lmRefreshCart);
document.querySelectorAll('[data-template^="product"] h1,[data-template^="product"] .rte').forEach(el=>el.setAttribute('dir','auto'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
